import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../../mgm_logo.png';
import { useCustomContext } from '../../state/CustomContext';
import { faBars, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { getEmptyUserInfo } from '../../utilities/helper';
export const Header = ({ setToggleForMenu }: any) => {
    const context = useCustomContext();
    const { state, dispatch } = context;
    return <div className='header'>
        {state.display_name && (<div className='menu-icon'>
            <FontAwesomeIcon className='white-label' icon={faBars} style={{ cursor: "pointer" }} onClick={() => {
                if (state.display_name) {
                    setToggleForMenu();
                }
            }} />
        </div>)}
        <div className='logo' > <img src={logo} alt="logo" /></div>
        <div className='title'><div>E Ambulance</div><div className='version'>(v3)</div></div>
        {state.display_name && <div className='user-info'>Welcome  {state.display_name}{`${state.role_name ? ` (${state.role_name})` : ""}`}</div>}
        {state.display_name && (<div title="Logout"><FontAwesomeIcon className='white-label' style={{ cursor: "pointer" }} icon={faRightFromBracket} onClick={() => {
            dispatch({
                type: 'UPDATE_LOGIN',
                ...getEmptyUserInfo()
            });
        }} /></div>)}
        {/* <SignOut  /> */}
    </div>
}